import React from "react";
import { Typography, Stack } from "@mui/material";
import { LocalizationProvider, MobileTimePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import { getMinTime } from "./utils";
import { useTranslation } from "react-i18next";

const CustomTimePicker = ({
  label,
  required,
  inputFormat,
  outputFormat,
  onChange,
  value, // dont remove this
  minDate,
  helperText,
  error,
  handleError,
  timeZone,
  ...rest
}) => {
  const [timeError, setTimeError] = React.useState("");
  const minTime = getMinTime(minDate, timeZone);
  const { t } = useTranslation();

  const errorMessageMapper = (err) =>
    ({
      invalidDate: t("components.customTimePicker.text01"),
      minTime: t("components.customTimePicker.text02"),
      maxDate: t("components.customTimePicker.text03"),
    })[err] || err;

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Stack spacing={1}>
        <Typography variant="customLable" color="common.inputCustomLable">
          {label}
          {required && <span style={{ color: "#C50F1F" }}>*</span>}
        </Typography>
        <MobileTimePicker
          {...rest}
          reduceAnimations
          disableIgnoringDatePartForTimeValidation
          format={inputFormat}
          onError={(error) => {
            setTimeError(errorMessageMapper(error));
            handleError(errorMessageMapper(error));
          }}
          onChange={(value) => {
            let formattedTime = value;
            if (outputFormat) {
              formattedTime = formattedTime?.format(outputFormat);
            }
            onChange(formattedTime);
          }}
          variant="outlined"
          fullWidth
          defaultValue={minTime}
          minTime={minTime}
          slotProps={{
            textField: {
              error: error || !!timeError,
              helperText: helperText || timeError,
              sx: { input: { cursor: "pointer" } },
            },
            dialog: {
              sx: {
                "& [class*='MuiPickersToolbar-content'] [class*='MuiButtonBase-root']":
                  {
                    backgroundColor: "white",
                    border: "1px solid lightgray",
                    margin: "1px 0",
                    color: "black",
                    padding: "10px",
                  },

                "& .MuiButtonBase-root:has(.Mui-selected)": {
                  background: "#1d5ab9",
                },

                "& .Mui-selected": {
                  background: "#1d5ab9",
                  color: "white !important",
                },

                "& .MuiTimePickerToolbar-ampmSelection": {
                  flexDirection: "row",
                  gap: 1,
                },
              },
            },
          }}
        />
      </Stack>
    </LocalizationProvider>
  );
};
export default CustomTimePicker;
